export default (props, {
  rhythm
}) => ({
  category: {
    paddingBottom: rhythm(1)
  }
})



// WEBPACK FOOTER //
// ./components/slices/Resources/styles.js